module.exports = __webpack_public_path__ + "img/transactions.68ef227d.svg";